import { Controller } from 'stimulus';

export default class extends Controller {
  connect() {
    this.render();
  }

  checkForSafariBug() {
    if (!this.element.querySelector('.safari-enabled:disabled')) return;

    this.element.innerHTML = this.element.innerHTML + '';
  }

  switch() {
    this.fieldsets().forEach(el => {
      if (el.disabled) {
        el.removeAttribute('disabled');
        el.classList.toggle('safari-enabled', true);
        el.classList.toggle('safari-disabled', false);
      }
      else {
        el.setAttribute('disabled', 'disabled');
        el.classList.toggle('safari-disabled', true);
        el.classList.toggle('safari-enabled', false);
      }
    });
    this.render();
  }

  fieldsets() {
    return this.allFieldsets().filter((el) => !this.nestedFieldsets().includes(el));
  }

  nestedFieldsets() {
    return Array.from(this.element.querySelectorAll('[data-controller]')).reduce((acc, el) => {
      if (!el.dataset.controller.includes(this.identifier)) return acc;

      return acc.concat(Array.from(el.querySelectorAll('fieldset')));
    }, []);
  }

  allFieldsets() {
    return Array.from(this.element.querySelectorAll('fieldset'));
  }

  render() {
    this.fieldsets().forEach(el => {
      el.classList.toggle('hidden', el.disabled);
    });
    this.checkForSafariBug();
  }
}
